/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { ContentBlock, FlexCol, FlexRow, Stack } from 'sarsaparilla';
import HeaderPlaceholder from './HeaderPlaceholder';
import SummaryPlaceholder from './SummaryPlaceholder';

export default function LoadingSkeleton() {
    return (
        <main id="page-body" className="ia-order-details-page">
            <ContentBlock className="mt-5 mb-5">
                <Stack>
                    <FlexRow>
                        <FlexCol lg={8}>
                            <HeaderPlaceholder />
                        </FlexCol>
                        <FlexCol lg={4} className="ia-order-details-summary">
                            <SummaryPlaceholder />
                        </FlexCol>
                    </FlexRow>
                </Stack>
            </ContentBlock>
        </main>
    );
}
